"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateListCountTypeInListCondition = exports.createNewFieldCondition = exports.createNewSectionCondition = exports.createNewListCondition = void 0;
const field_condition_1 = require("./field-condition");
const list_condition_1 = require("./list-condition");
const section_condition_1 = require("./section-condition");
function createNewListCondition(fieldName) {
    const listCondition = new list_condition_1.ListCondition();
    listCondition.listAccessor = fieldName;
    listCondition.listAccessorDisplay = fieldName;
    listCondition.countType = list_condition_1.ListCountType.atLeast;
    listCondition.count = 1;
    return listCondition;
}
exports.createNewListCondition = createNewListCondition;
function createNewSectionCondition(fieldName) {
    const sectionCondition = new section_condition_1.SectionCondition();
    sectionCondition.listAccessor = fieldName;
    sectionCondition.listAccessorDisplay = fieldName;
    return sectionCondition;
}
exports.createNewSectionCondition = createNewSectionCondition;
function createNewFieldCondition(fieldName, operator, value, negate) {
    const fieldCondition = new field_condition_1.FieldCondition();
    fieldCondition.fieldAccessor = fieldName;
    fieldCondition.operator = operator;
    fieldCondition.value = value;
    fieldCondition.negate = negate;
    return fieldCondition;
}
exports.createNewFieldCondition = createNewFieldCondition;
function updateListCountTypeInListCondition(listCondition, listCountType) {
    if (listCondition.countType !== list_condition_1.ListCountType.atLeast ||
        listCondition.count !== 1) {
        return listCondition;
    }
    listCondition.countType = listCountType.type;
    listCondition.count = listCountType.value;
    return listCondition;
}
exports.updateListCountTypeInListCondition = updateListCountTypeInListCondition;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/casa-rules-v2/condition-creator.js
// module id = 1247
// module chunks = 0